var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cs-group",
      on: {
        click: function ($event) {
          return _vm.activate(_vm.value)
        },
      },
    },
    [
      _vm.value.ImageAWSFile
        ? _c("div", {
            staticClass: "cs-group-image",
            style: {
              backgroundImage: "url(" + _vm.value.ImageAWSFile.getUrl() + ")",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "cs-group-info" }, [
        _vm._v(_vm._s(_vm.value.Name)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }